export const selectDiamond = (state) => {
  return state.diamonds.data.diamond;
};

export const selectSearchId = (state) => {
  return state.diamonds.data.searchId;
};
